module.exports = __webpack_public_path__ + "static/media/rpfpc_graduation_photo.5faaf636.png";